<script setup lang="ts">
import type { FrontendUserItem, FrontendUserPortraitPayload } from '@/api/modules/frontendUser'
import { FaAvatar, FaButton } from '@fantastic-admin/components'
import AppStatsCards from '@/components/AppDisplay/StatsCards.vue'
import { formatDateTime, profileCompleteness } from '../../utils/userDisplay'

defineOptions({ name: 'UserSocialTab' })

const props = defineProps<{
  user: FrontendUserItem
  portrait: FrontendUserPortraitPayload | null
  canNavigate: boolean
}>()
const emit = defineEmits<{ navigate: [] }>()

const stats = computed(() => [
  { label: '资料完整度', value: `${profileCompleteness(props.user)}%`, hint: '头像、地区、职业、兴趣及相册' },
  { label: '关注', value: props.portrait?.social.following_count ?? '-', hint: `粉丝 ${props.portrait?.social.follower_count ?? '-'}` },
  { label: '主页访问', value: props.portrait?.social.profile_view_total ?? '-', hint: '累计访问代理值', tone: 'info' as const },
  { label: '最近活跃', value: formatDateTime(props.user.last_login_time, '暂无'), hint: '以最近登录时间表示' },
])
</script>

<template>
  <div class="space-y-4">
    <AppStatsCards :items="stats" />
    <div class="gap-4 grid xl:grid-cols-[1fr_1.3fr]">
      <FaCard title="公开社交画像" content-class="pt-3">
        <div class="flex gap-4 items-start">
          <FaAvatar :src="user.avatar || ''" :fallback="user.nickname || user.username" size="64px" />
          <div class="min-w-0">
            <div class="font-semibold truncate">
              {{ user.display_name || user.nickname || user.username }}
            </div>
            <div class="text-sm text-muted-foreground leading-6 mt-1">
              {{ user.intro || user.signature || '暂未填写公开介绍' }}
            </div>
          </div>
        </div>
        <div class="mt-4">
          <div class="text-xs text-muted-foreground mb-2">
            兴趣标签
          </div>
          <div v-if="user.interest_tags?.length" class="flex flex-wrap gap-2">
            <FaTag v-for="tag in user.interest_tags" :key="tag" variant="outline">
              {{ tag }}
            </FaTag>
          </div>
          <div v-else class="text-sm text-muted-foreground">
            暂无兴趣标签
          </div>
        </div>
      </FaCard>
      <FaCard title="相册与关系判断" content-class="pt-3">
        <div v-if="user.photo_album?.length" class="gap-3 grid grid-cols-3 sm:grid-cols-4">
          <img v-for="(url, index) in user.photo_album.slice(0, 8)" :key="`${url}-${index}`" :src="url" alt="" class="border-default border rounded-3 w-full aspect-square object-cover">
        </div>
        <div v-else class="text-sm text-muted-foreground">
          暂无公开相册
        </div>
        <div class="mt-4 flex justify-end">
          <FaButton v-if="props.canNavigate" variant="outline" size="sm" @click="emit('navigate')">
            进入社交关系运营
          </FaButton>
        </div>
      </FaCard>
    </div>
  </div>
</template>
